// Stealth-Agent FE module — API client.
// Calls the SESSION-authed stealth admin endpoints (/api/v1/stealth-agent/admin-session/*)
// using the logged-in user's TG JWT. No secret in the browser. main_admin only
// (backend enforces). ISOLATED: this module imports nothing from TG's own pages.
import axios from 'axios';

const stealthApi = axios.create({
  baseURL: '/api/v1/stealth-agent/admin-session',
  timeout: 20000,
});

stealthApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const getDevices = (params = {}) =>
  stealthApi.get('/devices', { params }).then((r) => r.data);
export const exportDevicesCsv = (params = {}) =>
  stealthApi.get('/devices/export', { params, responseType: 'blob', timeout: 120000 }).then((r) => r);
export const getReports = (params = {}) =>
  stealthApi.get('/reports', { params }).then((r) => r.data);
export const getReport = (id) => stealthApi.get(`/reports/${id}`).then((r) => r.data);
export const search = (body) => stealthApi.post('/search', body).then((r) => r.data);
export const control = (body) => stealthApi.post('/control', body).then((r) => r.data);
export const pauseAll = () => stealthApi.post('/control/pause-all').then((r) => r.data);
/** Ephemeral read-only agent check (queue/process counts). Result expires ~60s. */
export const getLiveDiag = (params = {}) =>
  stealthApi.get('/live-diag', { params }).then((r) => r.data);
// Auto-update rollout (org-scoped by default). body: { version, scope?: 'org'|'all' }
export const rollout = (body) => stealthApi.post('/rollout', body).then((r) => r.data);
export const getDiagnostics = () =>
  stealthApi.get('/diagnostics', { params: { deep: 1 } }).then((r) => r.data);

// SSE AI-summary stream endpoints (consumed via useStealthAiStream hook).
export const WORK_SUMMARY_STREAM = '/api/v1/stealth-agent/admin-session/work-summary/stream';
export const ORG_INTEL_STREAM = '/api/v1/stealth-agent/admin-session/org-intelligence/stream';
export const HOURLY_INSIGHTS_STREAM = '/api/v1/stealth-agent/admin-session/hourly-insights/stream';

// Hourly slots (instant per-hour stats — no AI). tz = viewer browser timezone.
export const getHourlySlots = (params = {}) =>
  stealthApi.get('/hourly-insights/slots', { params }).then((r) => r.data);

export default stealthApi;

